// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formPane a {
  color: var(--color-text-link, #3b5998);
  text-decoration: none;
}

.formPane a:link {
  color: var(--color-text-link, #3b5998);
  text-decoration: none;
}

.formPane a:visited {
  color: var(--color-text-link-visited, #3b5998);
  text-decoration: none;
}

.formPane a:hover {
  color: var(--color-text-link-hover, #3b5998);
  font-weight: bold;
}

.formPane a:active {
  color: var(--color-text-link-active, #888);
  text-decoration: none;
}

.formPane__message,
.formPaneMessage {
  color: #666;
  margin: var(--spacing-xs, 0.5em) 0;
  padding: var(--spacing-xs, 0.35em) var(--spacing-xs, 0.5em);
}

.formPane__message--info {
  background-color: var(--color-main-block-bg, #eee);
}

.formPane__message--error {
  background-color: var(--color-log-error-bg, #fee);
}

.formPane__editButton {
  margin-left: auto;
  align-self: center;
  padding: var(--spacing-xs, 0.5rem);
  border: .5rem solid white;
  font-size: 100%;
  float: none;
}

.formPane .formPane__mobileTextareaValue > div {
  display: block;
  min-width: 0;
  position: relative;
}

.formPane .formPane__mobileTextareaValue > div > textarea {
  box-sizing: border-box;
  max-width: 100%;
  min-width: 0;
  width: 100%;
}

.formPane .formPane__mobileTextareaValue > div > button[type='button'] {
  float: none !important;
  position: absolute;
  right: 0;
  top: 0;
}

.formPane[data-layout='mobile'] .formPane__mobileTextareaRow {
  flex-direction: column !important;
  align-items: stretch;
}

.formPane[data-layout='mobile'] .formPane__mobileTextareaLabel {
  width: auto !important;
  padding-bottom: 0;
}

.formPane[data-layout='mobile'] .formPane__mobileTextareaValue {
  box-sizing: border-box;
  min-width: 0;
  padding-right: var(--spacing-sm, 0.75rem);
  width: 100%;
}

.formPane[data-layout='mobile'] .formPane__mobileTextareaValue textarea {
  box-sizing: border-box;
  margin-left: 0 !important;
  margin-right: 0 !important;
  max-width: 100%;
  width: 100%;
}

@media (max-width: 960px) {
  .formPane .formPane__mobileTextareaRow {
    flex-direction: column !important;
    align-items: stretch;
  }

  .formPane .formPane__mobileTextareaLabel {
    width: auto !important;
    padding-bottom: 0;
  }

  .formPane .formPane__mobileTextareaValue {
    box-sizing: border-box;
    min-width: 0;
    padding-right: var(--spacing-sm, 0.75rem);
    width: 100%;
  }

  .formPane .formPane__mobileTextareaValue textarea {
    box-sizing: border-box;
    margin-left: 0 !important;
    margin-right: 0 !important;
    max-width: 100%;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/form/formPane.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,kCAAkC;EAClC,2DAA2D;AAC7D;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;EACzB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,yCAAyC;IACzC,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,0BAA0B;IAC1B,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":[".formPane a {\n  color: var(--color-text-link, #3b5998);\n  text-decoration: none;\n}\n\n.formPane a:link {\n  color: var(--color-text-link, #3b5998);\n  text-decoration: none;\n}\n\n.formPane a:visited {\n  color: var(--color-text-link-visited, #3b5998);\n  text-decoration: none;\n}\n\n.formPane a:hover {\n  color: var(--color-text-link-hover, #3b5998);\n  font-weight: bold;\n}\n\n.formPane a:active {\n  color: var(--color-text-link-active, #888);\n  text-decoration: none;\n}\n\n.formPane__message,\n.formPaneMessage {\n  color: #666;\n  margin: var(--spacing-xs, 0.5em) 0;\n  padding: var(--spacing-xs, 0.35em) var(--spacing-xs, 0.5em);\n}\n\n.formPane__message--info {\n  background-color: var(--color-main-block-bg, #eee);\n}\n\n.formPane__message--error {\n  background-color: var(--color-log-error-bg, #fee);\n}\n\n.formPane__editButton {\n  margin-left: auto;\n  align-self: center;\n  padding: var(--spacing-xs, 0.5rem);\n  border: .5rem solid white;\n  font-size: 100%;\n  float: none;\n}\n\n.formPane .formPane__mobileTextareaValue > div {\n  display: block;\n  min-width: 0;\n  position: relative;\n}\n\n.formPane .formPane__mobileTextareaValue > div > textarea {\n  box-sizing: border-box;\n  max-width: 100%;\n  min-width: 0;\n  width: 100%;\n}\n\n.formPane .formPane__mobileTextareaValue > div > button[type='button'] {\n  float: none !important;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.formPane[data-layout='mobile'] .formPane__mobileTextareaRow {\n  flex-direction: column !important;\n  align-items: stretch;\n}\n\n.formPane[data-layout='mobile'] .formPane__mobileTextareaLabel {\n  width: auto !important;\n  padding-bottom: 0;\n}\n\n.formPane[data-layout='mobile'] .formPane__mobileTextareaValue {\n  box-sizing: border-box;\n  min-width: 0;\n  padding-right: var(--spacing-sm, 0.75rem);\n  width: 100%;\n}\n\n.formPane[data-layout='mobile'] .formPane__mobileTextareaValue textarea {\n  box-sizing: border-box;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  max-width: 100%;\n  width: 100%;\n}\n\n@media (max-width: 960px) {\n  .formPane .formPane__mobileTextareaRow {\n    flex-direction: column !important;\n    align-items: stretch;\n  }\n\n  .formPane .formPane__mobileTextareaLabel {\n    width: auto !important;\n    padding-bottom: 0;\n  }\n\n  .formPane .formPane__mobileTextareaValue {\n    box-sizing: border-box;\n    min-width: 0;\n    padding-right: var(--spacing-sm, 0.75rem);\n    width: 100%;\n  }\n\n  .formPane .formPane__mobileTextareaValue textarea {\n    box-sizing: border-box;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    max-width: 100%;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
